/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { AdminGetCoursesOptions, AdminGetCoursesStatus200, AdminGetCoursesStatus422 } from '../models/AdminGetCourses'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { adminGetCourses } from '../clients/axios/adminGetCourses'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const adminGetCoursesQueryKey = ({ query }: Omit<AdminGetCoursesOptions, 'headers'> = {}) => [{ url: '/admin/courses' }, ...(query ? [query] : [])] as const

type AdminGetCoursesQueryKey = ReturnType<typeof adminGetCoursesQueryKey>

export function adminGetCoursesQueryOptions({ query }: AdminGetCoursesOptions = {}, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = adminGetCoursesQueryKey({ query })
  return queryOptions<AdminGetCoursesStatus200, ResponseErrorConfig<AdminGetCoursesStatus422>, AdminGetCoursesStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await adminGetCourses({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Courses
 * {@link /admin/courses}
 */
export function useAdminGetCourses<TData = AdminGetCoursesStatus200, TQueryData = AdminGetCoursesStatus200, TQueryKey extends QueryKey = AdminGetCoursesQueryKey>({ query }: { query?: AdminGetCoursesOptions['query'] | (() => AdminGetCoursesOptions['query']) } = {}, options: {
  query?: Partial<QueryObserverOptions<AdminGetCoursesStatus200, ResponseErrorConfig<AdminGetCoursesStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? adminGetCoursesQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...adminGetCoursesQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AdminGetCoursesStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
